

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '博物馆名称',
      width: '300px'
    },
    {
      key: 'provincename',
      dataIndex: 'provincename',
      title: '省份',
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '质量等级',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '2019年',
      width: 100,
      slot: 'select1',
    },
    {
      key: 'recommend',
      dataIndex: 'recommend',
      title: '2020年',
      width: 100,
      slot: 'select2',
    },
    {
      key: 'add',
      dataIndex: 'add',
      title: '2021年',
      width: 100,
      slot: 'select3',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
